import { PaymentInformation } from "./PaymentInformation"

export class SettlementChoiceData{
  name=""
  subscription_choice: String = ""

  is_premium_subscription_type: number = 0
  amount: number = 0.0
  payment_mode:string=""
  pay_bill_amount: number = 0.0
  bill_item_amount: number = 0.0
  server_billing_chart_id : number = 0
  payment_info = new  PaymentInformation()

}
